import ChangePasswordPage from "Pages/Authentication/ChangePasswordPage";
import ForgetPasswordPage from "Pages/Authentication/ForgetPasswordPage";
import LoginPage from "Pages/Authentication/LoginPage";
import PasswordUpdatePage from "Pages/Authentication/PasswordUpdatePage";
import EnquiryPage from "Pages/Enquiry/EnquiryPage";
import ListOfMembers from "Pages/Members/ListOfMembers";
import MembersPage from "Pages/Members/MembersPage";
import ListOfProducts from "Pages/Products/ListOfProducts";
import ProductsPage from "Pages/Products/ProductsPage";
import ListOfServicesPage from "Pages/SERVICES/ListOfServicesPage";
import ServicesPage from "Pages/SERVICES/ServicesPage";
import { Navigate } from "react-router-dom";


const authProtectedRoutes = [
// {path: "/dashboard", component: <DashboardPage/>},
{path: "/change-password", component: <ChangePasswordPage/>},
{path: "/inquiry", component: <EnquiryPage/>},
{path: "/add-product", component: <ProductsPage/>},
{path: "/edit-product/:id", component: <ProductsPage/>},
{path:"/products",component: <ListOfProducts/>},
{path: "/services", component: <ListOfServicesPage/>},
{path: "/add-service", component: <ServicesPage/>},
{path: "/edit-service/:id", component: <ServicesPage/>},
{path: "/members", component: <ListOfMembers/>},
{path: "/add-member", component: <MembersPage/>},
{path: "/edit-member/:id", component: <MembersPage/>},
  {
    path: "/",
    exact: true,
    component: <Navigate to="/products" />,
  },
  { path: "*", component: <Navigate to="/products" /> },
];

const publicRoutes = [
  {path: "/login", component: <LoginPage/>},
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/update-password", component: <PasswordUpdatePage /> }
];

export { authProtectedRoutes, publicRoutes };